/**
 * @generated SignedSource<<fee20ccb26e9a430586ceaa0ce197bf3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailFramingOptions_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_item">;
  readonly " $fragmentType": "PdpSharedDetailFramingOptions_item";
};
export type PdpSharedDetailFramingOptions_item$key = {
  readonly " $data"?: PdpSharedDetailFramingOptions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailFramingOptions_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "49d0f6230269b3ea24a96b9d382155b5";

export default node;
